import styled from 'styled-components';

export const OrdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  height: fit-content;
  gap: 24px;
  padding: 40px;
`;

export const FiltersContainer = styled.form`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  height: 100%;

  label {
    flex: 1;
    position: relative;
    min-width: 264px;

    .searchInput {
      input {
        padding-left: 44px;
      }
    }

    .iconSearch {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      border-radius: 12px;
      left: 0px;
      top: 0px;
      height: 48px;
      width: 40px;

      svg {
        color: ${({ theme }) => theme.colors.orange.primary};
        height: 20px;
        width: 20px;
      }
    }

    input {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;

      &:active {
        transform: translate(1px, 1px);
      }
    }
  }

  .otherInput {
    &.select {
      max-width: 293px;
    }

    @media (max-width: 1024px) {
      max-width: 100%;
    }
  }
`;

export const TdConsult = styled.td`
  color: ${({ theme }) => theme.colors.blue.primary};
  text-decoration: underline;
  cursor: pointer;
`;
